import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { formatImageUrl } from '../utils/imageUtils';

const AppHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  // Get page title based on current route
  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/dashboard/patient')) return 'Account Dashboard';
    if (path.includes('/dashboard/doctor')) return 'Specialist Dashboard';
    if (path.includes('/dashboard/retailer')) return 'Store Dashboard';
    if (path.includes('/dashboard/clinic')) return 'Wellness Dashboard';
    if (path.includes('/dashboard/hospital')) return 'Support Dashboard';
    if (path.includes('/consultation')) return 'Session';
    if (path.includes('/medicines')) return 'Products';
    if (path.includes('/yoga')) return 'Live Sessions';
    if (path.includes('/podcasts')) return 'Expert Podcasts';
    if (path.includes('/orders')) return 'My Orders';
    return 'Vivara';
  };

  return (
    <header className="bg-dark border-b border-gold pt-[calc(1rem+env(safe-area-inset-top))] pb-4 px-4 w-full shadow-md">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <img src={formatImageUrl('/logo.png')} alt="Vivara Logo" className="w-8 h-8 rounded-full mr-3 object-cover border-2 border-gold" />
          <h1 className="text-xl font-bold text-light">{getPageTitle()}</h1>
        </div>
        <div className="flex items-center space-x-4">
          <button
            onClick={() => window.location.reload()}
            className="text-gold p-1 hover:bg-gray-800 rounded-full transition-colors"
            title="Refresh App"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
          </button>
          <button
            onClick={() => navigate('/patient/notifications')}
            className="text-gold p-1 hover:bg-gray-800 rounded-full transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
          </button>
          <button
            onClick={() => {
              const effectiveRole = ['clinic_doctor', 'hospital_doctor'].includes(user?.role) ? 'doctor' : user?.role;
              navigate(user?.role === 'patient' ? '/patient/profile' : `/dashboard/${effectiveRole}/profile`);
            }}
            className="text-gold p-1 hover:bg-gray-800 rounded-full transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default AppHeader;